import { render, staticRenderFns } from "./player-list.vue?vue&type=template&id=756c19e5&scoped=true"
import script from "./player-list.vue?vue&type=script&lang=js"
export * from "./player-list.vue?vue&type=script&lang=js"
import style0 from "./player-list.vue?vue&type=style&index=0&id=756c19e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756c19e5",
  null
  
)

export default component.exports